/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Verkehrsart } from '../models';
/**
 * VerkehrsartService - axios parameter creator
 * @export
 */
export const VerkehrsartServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Verkehrsart
         * @summary Verkehrsarten
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerkehrsartById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVerkehrsartById', 'id', id)
            const localVarPath = `/api/verkehrsarten/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Verkehrsarten
         * @summary Verkehrsarten
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerkehrsarten: async (mandant?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/verkehrsarten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VerkehrsartService - functional programming interface
 * @export
 */
export const VerkehrsartServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VerkehrsartServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Verkehrsart
         * @summary Verkehrsarten
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVerkehrsartById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Verkehrsart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVerkehrsartById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Verkehrsarten
         * @summary Verkehrsarten
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVerkehrsarten(mandant?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Verkehrsart>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVerkehrsarten(mandant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VerkehrsartService - factory interface
 * @export
 */
export const VerkehrsartServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VerkehrsartServiceFp(configuration)
    return {
        /**
         * Liefert eine Verkehrsart
         * @summary Verkehrsarten
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerkehrsartById(id: number, options?: any): AxiosPromise<Verkehrsart> {
            return localVarFp.getVerkehrsartById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Verkehrsarten
         * @summary Verkehrsarten
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVerkehrsarten(mandant?: number, options?: any): AxiosPromise<Array<Verkehrsart>> {
            return localVarFp.getVerkehrsarten(mandant, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VerkehrsartService - interface
 * @export
 * @interface VerkehrsartService
 */
export interface VerkehrsartServiceInterface {
    /**
     * Liefert eine Verkehrsart
     * @summary Verkehrsarten
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerkehrsartServiceInterface
     */
    getVerkehrsartById(id: number, options?: any): AxiosPromise<Verkehrsart>;

    /**
     * Liefert eine Liste von Verkehrsarten
     * @summary Verkehrsarten
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerkehrsartServiceInterface
     */
    getVerkehrsarten(mandant?: number, options?: any): AxiosPromise<Array<Verkehrsart>>;

}

/**
 * VerkehrsartService - object-oriented interface
 * @export
 * @class VerkehrsartService
 * @extends {BaseAPI}
 */
export class VerkehrsartService extends BaseAPI implements VerkehrsartServiceInterface {
    /**
     * Liefert eine Verkehrsart
     * @summary Verkehrsarten
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerkehrsartService
     */
    public getVerkehrsartById(id: number, options?: any) {
        return VerkehrsartServiceFp(this.configuration).getVerkehrsartById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Verkehrsarten
     * @summary Verkehrsarten
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerkehrsartService
     */
    public getVerkehrsarten(mandant?: number, options?: any) {
        return VerkehrsartServiceFp(this.configuration).getVerkehrsarten(mandant, options).then((request) => request(this.axios, this.basePath));
    }
}
